// Session recorders — parity with the current live Nikura theme, loaded during parsing as live does.

// Microsoft Clarity.
(function (c, l, a, r, i) {
  c[a] =
    c[a] ||
    function () {
      (c[a].q = c[a].q || []).push(arguments);
    };
  const t = l.createElement(r);
  t.async = true;
  t.src = `https://www.clarity.ms/tag/${i}`;
  t.crossOrigin = 'anonymous';
  l.head.appendChild(t);
})(window, document, 'clarity', 'script', 'q22t48zo95');

// Heatmap.com (live `snippets/cw-convert-heatmaps.liquid`).
(function (w, d, sid) {
  w._heatmap_paq = w._heatmap_paq || [];
  const baseUrl = (w.heatUrl = 'https://dashboard.heatmap.com/');

  /**
   * @param {string} url
   * @param {() => void} [onLoad]
   */
  const addScript = (url, onLoad) => {
    const script = d.createElement('script');
    script.src = url;
    if (onLoad) script.addEventListener('load', onLoad, { once: true });
    d.head.appendChild(script);
  };

  // The preprocessor may queue its own tracker; only when it hasn't does the light tracker load. The
  // check waits for the preprocessor to run, and reads the queue live because the preprocessor may replace it.
  addScript(`${baseUrl}preprocessor.min.js?sid=${sid}`, () => {
    const queue = w._heatmap_paq;
    if (typeof queue === 'object' && queue !== null && queue.length > 0) return;
    w._heatmap_paq = queue || [];
    w._heatmap_paq.push(['setTrackerUrl', `${baseUrl}sttracker.php`]);
    addScript(`${baseUrl}heatmap-light.min.js?sid=${sid}`);
  });
})(window, document, 1781);
